var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-data-table',{attrs:{"headers":_vm.getHeaders,"items":_vm.items,"items-per-page":-1,"disable-pagination":"","hide-default-footer":""},scopedSlots:_vm._u([{key:"item.cobrado",fn:function({item}){return [(item.cobrado != undefined && item.cobrado != null)?[_vm._v(" $"+_vm._s(_vm.getFixedNumber(item.cobrado))+" ")]:_vm._e()]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }